/* eslint-disable arrow-parens */
import { RestClient } from '../network';

const emaginApi = {
  fetchCountries: (lang) =>
    new RestClient(`/referential/countries/${lang}`, 'GET').execute(),
};

export default emaginApi;
